import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';

@Component({
  selector: 'app-test-table',
  templateUrl: './test-table.component.html',
  styleUrls: ['./test-table.component.css']
})
export class TestTableComponent implements OnInit {

  source: LocalDataSource = new LocalDataSource();
  settings = {
    actions: {
      add: true
    },
    add: {
      addButtonContent: 'Add New',
      createButtonContent: 'Create ',
    },
    edit: {
      editButtonContent: '<i class="material-icons">edit</i>',
      saveButtonContent: '<i class="material-icons">check</i>',
      cancelButtonContent: '<i class="material-icons">clear</i>',
      confirmSave: true
    },
    delete: {
      deleteButtonContent: '<i class="material-icons">delete</i>',
    },
    mode: 'inline',
    columns: {
      activity: {
        title: 'Activity',
      },
      minutes: {
        title: 'Minutes',
      },
      date: {
        title: 'Date',
      }
    },
    pager: {
      display: false,
      perPage: 5,
    },
  };
  data = [];

  constructor(
    private bkOffService: BackOffServiceService
  ) {
    // this.source = new LocalDataSource(this.data);
  }

  ngOnInit() {
    this.bkOffService.getActivityHistory().then((res) => {
      res.forEach(element => {
        this.data.push({activity: element.activity, minutes: element.time, date: element.activityDate});
      });
      this.source.load(this.data);
    });
  }

  public onEditConfirm(event) : void {
    console.log(event.newData);
  }

  onSearch(query: string = '') {
    this.source.setFilter([
      // fields we want to include in the search
      {
        field: 'id',
        search: query
      },
      {
        field: 'name',
        search: query
      },
      {
        field: 'username',
        search: query
      },
      {
        field: 'email',
        search: query
      }
    ], false); 
    // second parameter specifying whether to perform 'AND' or 'OR' search 
    // (meaning all columns should contain search query or at least one)
    // 'AND' by default, so changing to 'OR' by setting false here
  }

}
